import FormCheckbox from "./FormCheckbox";
import FormInput from "./FormInput";
import React from "react";

function FormFieldGroup({ fields, handleChange }) {
  return fields.map((field) => {
    if (field.type === "checkbox") {
      return (
        <FormCheckbox
          key={field.name}
          name={field.name}
          checked={field.value}
          label={field.label}
          error={field.error}
          handleChange={() => {
            handleChange({
              [field.name]: {
                value: !field.value,
                error: null,
              },
            });
          }}
        />
      );
    } else if (
      field.type === "text" ||
      field.type === "email" ||
      field.type === "tel"
    ) {
      return (
        <FormInput
          key={field.name}
          name={field.name}
          value={field.value}
          error={field.error}
          placeholder={field.placeholder}
          handleChange={(event) => {
            handleChange({
              [field.name]: {
                value: event.target.value,
                error: null,
              },
            });
          }}
          type={field.type}
          label={field.label}
          autoComplete={field.autoComplete}
        />
      );
    }
  });
}

export default FormFieldGroup;
